import { updatePaidBags } from '../handleDetailsCheckout/handleDetailsCheckout'

export const buildShopSearchRedirectObject = ({
  proposalComponents = [],
  itemKey,
  priceKey,
  componentKey,
  searchRequest,
  flyIndex,
  price,
  itinerarySlices,
  selectedSeats = [],
}) => {
  const { params } = searchRequest
  const {
    'cart-key': cartKey,
    'usp-cache-key': uspCacheKey,
    'basket-key': basketKey,
    'bundle-type': bundleType,
  } = params

  const flyComponentKey = params['component-key'] ?? componentKey
  const componentIndex = Number(params['component-index'] || flyIndex)

  const flyAncillary = {}
  if (selectedSeats?.length > 0) {
    flyAncillary.seats = selectedSeats
  }
  flyAncillary.bags = updatePaidBags()

  const components = [
    {
      index: componentIndex,
      type: 'FLY',
      key: flyComponentKey,
      itemKey,
      priceKey,
      flyAncillary,
    },
  ]

  proposalComponents?.forEach((component) => {
    if (component.type !== 'FLY') {
      components.push({
        index: component?.componentIndex,
        type: component?.type,
        key: component?.componentKey,
        itemKey: component?.itemKey,
        priceKey: component?.priceKey,
      })
    }
  })

  const totalPrice = price?.find((priceNode) => priceNode.type === 'TOTAL_PRICE')

  const shopSearchRedirectObj = {
    pivotKey: flyComponentKey,
    components,
    totalCost: totalPrice?.amount,
  }

  /**
   * Don't move inside checkoutObj as Packages receives cartKey as 'undefined' string
   * */
  if (cartKey) {
    shopSearchRedirectObj.cartKey = cartKey
  }
  if (uspCacheKey) {
    shopSearchRedirectObj.uspCacheKey = uspCacheKey
  }
  if (basketKey) {
    shopSearchRedirectObj.basketKey = basketKey
  }
  if (bundleType) {
    const packageProductMap = {
      A: 1,
      H: 5,
      C: 8,
    }

    shopSearchRedirectObj.tripType = [...bundleType].reduce((trip, currentProduct) => {
      const productId = packageProductMap[currentProduct] ?? ''
      if (productId) trip.push(productId)
      return trip
    }, [])
  }

  if (itinerarySlices) {
    // this block is kept for backwards compatibility
    shopSearchRedirectObj.flyArrivalDateTime = itinerarySlices?.[0]?.arrivalInfo?.time?.dateTime
    shopSearchRedirectObj.flyDepartDateTime = itinerarySlices?.[1]?.departInfo?.time?.dateTime
    shopSearchRedirectObj.flyArrivalAirport = itinerarySlices?.[0]?.arrivalInfo?.airport?.code
    shopSearchRedirectObj.flyArrivalAirportName = itinerarySlices?.[0]?.arrivalInfo?.airport?.name
    shopSearchRedirectObj.flyReturnFlightDepartAirport = itinerarySlices?.[1]?.departInfo?.airport?.code
    shopSearchRedirectObj.flyReturnFlightDepartAirportName = itinerarySlices?.[1]?.departInfo?.airport?.name

    // new payload format to improve the mess I did above
    if (itinerarySlices?.length > 0) {
      shopSearchRedirectObj.slices = itinerarySlices.map((slice) => ({
        departInfo: {
          code: slice?.departInfo?.airport?.code,
          name: slice?.departInfo?.airport?.name,
          dateTime: slice?.departInfo?.time?.dateTime,
        },
        arrivalInfo: {
          code: slice?.arrivalInfo?.airport?.code,
          name: slice?.arrivalInfo?.airport?.name,
          dateTime: slice?.arrivalInfo?.time?.dateTime,
        },
      }))
    }
  }

  return shopSearchRedirectObj
}
